import { ReactNode } from "react";
import { ToastProviderProps } from "@chakra-ui/react";

import { Toast } from "../components/shared/Toast";
import { APP_MAX_WIDTH } from "../theme/components";

export const toastConfig: ToastProviderProps = {
  defaultOptions: {
    isClosable: true,
    duration: 5000,
    position: "top",
    containerStyle: {
      minWidth: "0",
      width: "100%",
      maxWidth: APP_MAX_WIDTH,
      mb: "0",
      px: "10px",
    },
    render(props): ReactNode {
      return (
        <Toast message={props.description} onClose={props.onClose} />
      );
    },
  },
};
